import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Drawer,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASE_IMAGE_URL, BASE_URL } from "../../../config/apiConfig";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useAmpltiudeEventTrackingContext } from "../../../contexts/AmplitudeTrackingContext";
import { getHeaders } from "../../../utils/apiUtils";
import debuggerInstance from "../../../components/common/userFeedback/DebugComponent/debugger";
import PineconeIndexDropdown from "../../../components/forms/Dropdowns/PineconeIndexDropdown";
import { useDebugger } from "../../../contexts/DebuggerContext";
import StyledCard from "../../../components/ui/cards/StyledCard";
import StyledImageCarousel from "../../../components/ui/StyledImageCarousel";
import SingleSelectGarmentWindow from "../../../components/layout/Interactive/SingleSelectGarmentWindow";
import { showAlert, showAlertWithMessage } from "../../../components/common/userFeedback/CustomAlert";
import CustomModal from "../../../components/common/userFeedback/CustomModal";
import LoadingOverlay from "../../../components/common/userFeedback/LoadingOverlay";
import { APP_BAR_HEIGHT } from "../../../components/layout/AppBar/AppBarComponent";

import DatasetDropdown from "../../../components/forms/Dropdowns/DatasetDropdown";
import TakeActionScreenCover from "../../../components/common/userFeedback/TakeActionScreenCover";
import ImageIndexButtons from "../../../components/ui/buttons/ImageIndexButtons";
import StyledButton from "../../../components/ui/buttons/StyledButton";
import PageChangeButton from "../../../components/ui/buttons/PageChangeButton";
import { formatToSpacedCapitalizedWords, logPerformancePoint } from "../../../utils/sharedFunctions";
import { GARMENT_SUMMONING_LIMIT } from "../../../config/summoningConfig";
import { useAuth } from "../../../contexts/AuthContext";
import NoDataScreenCover from "../../../components/common/userFeedback/NoDataScreenCover";
import LoadingBar from "../../../components/ui/LoadingBar";
import RepresentativeGarmentModal from "../../../components/common/userFeedback/RepresentativeGarmentModal";
const SKIP_ID = 4908182;
const screenConfig = {
  slipstream: {
    title: "Cataloguing Slipstream",
    routePrefix: "slipstream",
  },
  groups: {
    title: "Cataloguing Groups",
    routePrefix: "groups",
  },
};
function CataloguingTool({ config }) {
  const { palette, typography } = useTheme();
  const { title, routePrefix } = screenConfig[config];

  const { isAdmin, isToolTester } = useAuth();

  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(12);
  const [imageIndex, setImageIndex] = useState(1);
  const [maxPage, setMaxPage] = useState(
    Math.round(GARMENT_SUMMONING_LIMIT / pageSize)
  );
  const [presentedTimestamp, setPresentedTimeStamp] = useState(Date.now());

  const { trackEvent } = useAmpltiudeEventTrackingContext();
  const [indexSummary, setIndexSummary] = useState({});
  const [pagesVisited, setPagesVisited] = useState([1]);

  const [garments, setGarments] = useState([]);
  const [seedGarment, setSeedGarment] = useState({});
  const [seedGarmentVector, setSeedGarmentVector] = useState(null);
  const [summonTotal, setSummonTotal] = useState(0);
  const [seedGarmentGroupID, setSeedGarmentGroupID] = useState(null);
  const [seedGarmentImages, setSeedGarmentImages] = useState([]);
  const [selectedCatalogueItem, setSelectedCatalogueGarment] = useState({});
  const [metaData, setMetaData] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const [catalogueExhausted, setCatalogueExhausted] = useState(false);
  const [associateGarmentModalOpen, setAssociatedGarmentModalOpen] =
    useState(false);
  const theme = useTheme();

  const [
    updateGroupRepresentativeModalOpen,
    setUpdateGroupRepresentativeModalOpen,
  ] = useState(false);
  const [selectedDataset, setSelectedDataset] = useState(null);
  const [openSearchIndex, setOpenSearchIndex] = useState(null);
  const [numberOfColumns, setNumberOfColumns] = useState(4);
  const [summonOnlyQAGroups, setSummonOnlyQAGroups] = useState(false);

  const [time, setTime] = useState(0);
  const timerLengthSeconds = (isToolTester && isAdmin) ? 0 : pageSize * 1;

  const [toolID, setToolID] = useState(0);
  const toolName = `Cataloguing${routePrefix.charAt(0).toUpperCase() + routePrefix.slice(1)}Tool`

  const [totalGarmentsSeen, setTotalGarmentsSeen] = useState(0);
  const [garmentsSeen, setGarmentsSeen] = useState(0);
  
  const { addLog } = useDebugger();

  useEffect(() => {
    fetchToolData();
    fetchSummonCount();
    setTotalGarmentsSeen(0);
  }, [])

  useEffect(() => {
    if (openSearchIndex && seedGarmentVector && page && pageSize && !showLoader) {
      const start = Date.now();
      const interval = setInterval(() => {
        const elapsed = (Date.now() - start) / 1000; // seconds
        setTime(Math.min(elapsed, timerLengthSeconds)); // clamp to 30
      }, 100);
    
      return () => clearInterval(interval);
    }
  }, [page, pageSize, seedGarmentVector, openSearchIndex, showLoader]);

  useEffect(() => {
    resetState()
  }, [openSearchIndex, config])

  // Lifecycle Methods
  useEffect(() => {
    if (openSearchIndex) {
      fetchNamespaceData();
    }
  }, [selectedDataset, openSearchIndex, config]);

  useEffect(() => {
    if (indexSummary && (indexSummary.namespaceStats?.vectorNamespaceId || selectedDataset?.id)) {
      fetchSummonCount();
      fetchSeedGarment();
      setPagesVisited([1])
    }
  }, [indexSummary, config, summonOnlyQAGroups])

  useEffect(() => {
    setPageSize(numberOfColumns * 3);
    setGarments([]);
  }, [numberOfColumns]);

  useEffect(() => {
    setMaxPage(
      Math.min(
        Math.round((indexSummary?.namespaceStats?.recordCount ? indexSummary?.namespaceStats?.recordCount / pageSize : 1)),
        Math.round(GARMENT_SUMMONING_LIMIT / pageSize)
      )
    );
  }, [pageSize, GARMENT_SUMMONING_LIMIT, indexSummary, numberOfColumns])

  useEffect(() => {
    if (openSearchIndex && seedGarmentVector && page && pageSize) {
      queryCatalog({
        vector: seedGarmentVector,
        offset: page,
        page_size: pageSize,
        index: openSearchIndex,
      });
      setPresentedTimeStamp(Date.now);
    }
  }, [page, pageSize, seedGarmentVector, openSearchIndex]);

  useEffect(() => {
    setPage(1);
    setPagesVisited([1])
  }, [pageSize]);

  useEffect(() => {
    if (
      selectedCatalogueItem &&
      Object.keys(selectedCatalogueItem).length > 0
    ) {
      setAssociatedGarmentModalOpen(true);
    }
  }, [selectedCatalogueItem]);

  const fetchToolData = async () => {
    const headers = await getHeaders();
    const formattedToolName = formatToSpacedCapitalizedWords(toolName);
    let url = `${BASE_URL}tools/jobs/tool-names?toolName=${toolName}`;
    axios
      .get(url, headers)
      .then((res) => {
        console.log(`tool info: ${JSON.stringify(res.data.data)}`);
        if (res.data.data && res.data.data.length > 0 && res.data.data[0].id && res.data.data[0].id > 0)
        {
          setToolID(res.data.data[0].id)
        } else {
          const err = `Could not find tool ID in 'tool_names' with name '${formattedToolName}' (formatted from '${toolName}').`
          console.log(err);
          showAlert(err);
        }
      })

      .catch((err) => {
        console.log(err);
        showAlert(err);
      });
  };

  // Axios methods
  const fetchSeedGarment = async () => {
    const headers = await getHeaders();
    setPage(1);
    setImageIndex(1);
    setGarmentsSeen(0);
    setShowLoader(true);
    setButtonDisabled(true);
    const offsetLimit = 10;
    const params = {
      dataset: selectedDataset?.id,
      indexId: indexSummary?.namespaceStats?.vectorNamespaceId,
      offsetLimit: offsetLimit,
      vectorNamespaceSize: summonTotal ?? 0,
      onlyQAGroups: summonOnlyQAGroups
    };
    if (!params.dataset && !params.indexId)
    {
      console.error(`Need to select a dataset or index.`)
      showAlert(`Need to select a dataset or index.`)
      setButtonDisabled(false);
    } else {
      setShowLoader(true);
      try {
        const headers = await getHeaders();
        const res = await axios.post(
          `${BASE_URL}tools/summon/next-item/cataloguing/${routePrefix}`,
          params,
          headers
        )
  
        const t0 = logPerformancePoint(0);
        resetState();
        addLog(res.data.data);
        let { num_images, uuid_public_id } = res.data.data;
        let imageUrls = [];
        for (let i = 1; i <= num_images; i++) {
          let imageUrl = `${BASE_IMAGE_URL}${uuid_public_id}-${i}.jpg`;
          imageUrls.push(imageUrl);
        }
        const t1 = logPerformancePoint(1, t0);
        setSeedGarmentImages(imageUrls);
        setSeedGarment({...res.data.data, images: imageUrls});
        setSeedGarmentVector(res.data.data.vector);
        setSeedGarmentGroupID(res.data.data.group_id);
  
        const t2 = logPerformancePoint(2, t1);
        
        setShowLoader(false);
        setButtonDisabled(false);
      } catch (err) {
        let error = err
        if (summonTotal === 0)
        {
          error.message = "No data found."
          showAlertWithMessage(error.message, "error");
        } else {
          showAlert(error);
        }
        console.log(error);
        setShowLoader(false);
        setButtonDisabled(false);
      };
    }
  };

  const fetchNamespaceData = async () => {
    setShowLoader(true);
    setButtonDisabled(true);
    const headers = await getHeaders();
    let url = `${BASE_URL}tools/cataloguing/summarystats?`;
    if (openSearchIndex) {
      url += `namespace=${openSearchIndex}&index=catalogue`;
    }
    axios
      .get(url, headers)
      .then((res) => {
        setIndexSummary(res.data.data);
        //Set the max page based on the number of garments in the index or the limit to 200 garments
        setMaxPage(
          Math.min(
            Math.round((res.data.data?.namespaceStats?.recordCount ? res.data.data?.namespaceStats?.recordCount / pageSize : 1)),
            Math.round(GARMENT_SUMMONING_LIMIT / pageSize)
          )
        );
        setShowLoader(false);
        setButtonDisabled(false);
      })
      .catch((err) => {
        console.log(err);
        showAlert(err);
        setShowLoader(false);
        setButtonDisabled(false);
      });
  };

  const fetchSummonCount = async () => {
    const headers = await getHeaders();
    const params = {
      dataset: selectedDataset?.id,
      indexId: indexSummary?.namespaceStats?.vectorNamespaceId,
      onlyQAGroups: summonOnlyQAGroups
    };
    if (!params.dataset && !params.indexId)
    {
      console.error(`Need to select a dataset or index.`)
      showAlert(`Need to select a dataset or index.`)
    } else {
      setButtonDisabled(true);
      setShowLoader(true);
      try {
        const headers = await getHeaders();
        const res = await axios.post(
          `${BASE_URL}tools/summon/count/cataloguing/${routePrefix}`,
          params,
          headers
        )
  
        const t0 = logPerformancePoint(0);
        setSummonTotal(res.data.data.total_count);
        console.log(`res.data.data.total_count: ${res.data.data.total_count}`)
        const t1 = logPerformancePoint(1, t0);
        
        setShowLoader(false);
        setButtonDisabled(false);
      } catch (err) {
        showAlert(err);
        setShowLoader(false);
        setButtonDisabled(false);
      };
    }
  };

  const queryCatalog = async (params) => {
    const headers = await getHeaders();
    setButtonDisabled(true);
    setShowLoader(true);
    axios
      .post(`${BASE_URL}tools/cataloguing/querypinecone`, params, headers)
      .then((res) => {
        const results = res.data.data.slice(0, pageSize);
        setGarments(results);

        if (results.length === pageSize) {
          setCatalogueExhausted(false);
        } else {
          setCatalogueExhausted(true);
        }
        setShowLoader(false);
        setButtonDisabled(false);
      })
      .catch((err) => {
        console.log(err);
        showAlert(err);
        setShowLoader(false);
        setButtonDisabled(false);
      });
  };

  const createNewCatalogItem = async () => {
    const headers = await getHeaders();
    setTotalGarmentsSeen(totalGarmentsSeen + (pageSize * (page - 1)));
    setGarmentsSeen(garmentsSeen + (pageSize * (page - 1)));
    const updatedGarmentsSeen = garmentsSeen + (pageSize * (page - 1))
    const updatedTotalGarmentsSeen = totalGarmentsSeen + (pageSize * (page - 1))
    const params = {
      index: openSearchIndex,
      newGroupRepresentativeGarmentId: seedGarment.garment_id,
      vectorNamespaceId: indexSummary.namespaceStats.vectorNamespaceId,
      vectorNamespaceSize: indexSummary?.namespaceStats?.recordCount ?? 0,
      uuidPublicId: seedGarment.uuid_public_id,
      vector: seedGarment.vector,
      confidence: 0.4,
      garmentsSeen: updatedGarmentsSeen,
      jobId: config === "slipstream" ? 42 : 41,
      pipelineJobId: null,
      toolId: toolID,
      presentedTimestamp: presentedTimestamp,
      proposedTimestamp: Date.now(),
    };
    setShowLoader(true);
    setButtonDisabled(true);

    axios
      .post(`${BASE_URL}tools/classify/new/cataloguing`, params, headers)
      .then((res) => {
        trackEvent("CatalogueItem", {
          garmentId: seedGarment.garment_id,
          proposedBy: res.data.data.user_id,
          jobName: "cataloguing",
          jobId: config === "slipstream" ? 42 : 41,
          pipelineJobId: null,
          toolType: `CATALOGUING${
            config === "slipstream" ? "_SLIPSTREAM" : ""
          }`,
          toolName: "CataloguingTool",
          toolId: toolID,
          action: "APPEND",
          confidence: 0.4,
          index: seedGarment.index,
          vector: seedGarment.vector,
          garmentsSeen: updatedGarmentsSeen,
          totalGarmentsSeen: updatedTotalGarmentsSeen,
          uuidPublicId: seedGarment.uuid_public_id,
          associatedProposalGroupUuid: res.data.data.new_group_id,
          usedVectorNamespaceId: indexSummary.namespaceStats.vectorNamespaceId ?? 0,
          skipped: false,
          qa: false,
          slipstream: config === "slipstream",
          updateGroupRepresentative: false,
        });

        resetState();
        fetchNamespaceData();
        setButtonDisabled(false);
      })
      .catch((err) => {
        showAlert(err);
        setGarmentsSeen(0);
        setButtonDisabled(false);
        setShowLoader(false);
      });
  };

  const handleUpdateGroupRepresentative = async (seedGroupID, updatedGarmentsSeen, updatedTotalGarmentsSeen) => {
    const headers = await getHeaders();
    console.log(`seedGarmentGroupID: ${seedGarmentGroupID}`)
    const params = {
      index: openSearchIndex,
      newGroupRepresentativeGarmentId: seedGarment.garment_id,
      newGroupRepresentativeGroupId: seedGroupID ?? seedGarmentGroupID,
      previousGroupRepresentativeGarmentId: selectedCatalogueItem.garment_id,
      previousGroupRepresentativeGarmentRank: selectedCatalogueItem.index,
      previousGroupRepresentativeGarmentScore: selectedCatalogueItem.score,
      vectorNamespaceId: indexSummary.namespaceStats.vectorNamespaceId,
      vectorNamespaceSize: indexSummary?.namespaceStats?.recordCount ?? 0,
      uuidPublicId: seedGarment.uuid_public_id,
      vector: seedGarment.vector,
      confidence: 0.4,
      garmentsSeen: updatedGarmentsSeen,
      jobId: config === "slipstream" ? 42 : 41,
      pipelineJobId: null,
      toolId: toolID,
      presentedTimestamp: presentedTimestamp,
      proposedTimestamp: Date.now()
    };
    setShowLoader(true);
    setButtonDisabled(true);
    axios
      .post(
        `${BASE_URL}tools/classify/replace-catalogue-representative/cataloguing`,
        params,
        headers
      )
      .then((res) => {
        trackEvent("CatalogueItemUpdateRepresentative", {
          garmentId: seedGarment.garment_id,
          proposedBy: res.data.data.user_id,
          jobName: "cataloguing",
          toolType: `CATALOGUING${
            config === "slipstream" ? "_SLIPSTREAM" : ""
          }`,
          toolName: "CataloguingTool",
          jobId: config === "slipstream" ? 42 : 41,
          pipelineJobId: null,
          toolId: toolID,
          action: "REP_APPEND",
          confidence: 1.0,
          index: seedGarment.index,
          garmentsSeen: updatedGarmentsSeen,
          totalGarmentsSeen: updatedTotalGarmentsSeen,
          vector: seedGarment.vector,
          uuidPublicId: seedGarment.uuid_public_id,
          previousGarmentId: selectedCatalogueItem.garment_id,
          newGarmentId: seedGarment.garment_id,
          usedVectorNamespaceId: indexSummary.namespaceStats.vectorNamespaceId ?? 0,
          skipped: false,
          qa: false,
          slipstream: config === "slipstream",
        });

        resetState();
        fetchNamespaceData();
        setButtonDisabled(false);
      })
      .catch((err) => {
        showAlert(err);
        setButtonDisabled(false);
      });
  };

  const asssociateToCatalogItem = async (update_representative, bin=false) => {
    const headers = await getHeaders();
    setShowLoader(true);
    setButtonDisabled(true);
    setTotalGarmentsSeen(totalGarmentsSeen + ((selectedCatalogueItem?.index ?? 0) + pageSize * (page - 1)));
    setGarmentsSeen(garmentsSeen + ((selectedCatalogueItem?.index ?? 0) + pageSize * (page - 1)));
    const updatedGarmentsSeen = garmentsSeen + ((selectedCatalogueItem?.index ?? 0) + pageSize * (page - 1))
    const updatedTotalGarmentsSeen = totalGarmentsSeen + ((selectedCatalogueItem?.index ?? 0) + pageSize * (page - 1))
    if (!buttonDisabled && indexSummary?.namespaceStats?.vectorNamespaceId)
    {
      const params = {
        index: openSearchIndex,
        catalogueRepresentativeGarmentId: seedGarment.garment_id,
        associatedGarment: bin
        ? {
          score: 1, 
          index: 1
        }
        : {
          ...selectedCatalogueItem,
          index: selectedCatalogueItem.index + pageSize * (page - 1),
        },
        seedGarmentId: seedGarment.garment_id,
        seedGarmentGroupId: seedGarment.group_id,
        vectorNamespaceId: indexSummary.namespaceStats.vectorNamespaceId,
        vectorNamespaceSize: indexSummary?.namespaceStats?.recordCount ?? 0,
        uuidPublicId: seedGarment.uuid_public_id,
        vector: seedGarment.vector,
        confidence: 0.4,
        garmentsSeen: updatedGarmentsSeen,
        jobId: config === "slipstream" ? 42 : 41,
        pipelineJobId: null,
        toolId: toolID,
        presentedTimestamp: presentedTimestamp,
        proposedTimestamp: Date.now(),
        isBin: bin
      };
      const t0 = logPerformancePoint(0);
      await axios
        .post(`${BASE_URL}tools/classify/associate/cataloguing`, params, headers)
        .then((res) => {
          const t1 = logPerformancePoint(1, t0);
          
          trackEvent("CatalogueItem", {
            garmentId: seedGarment.garment_id,
            proposedBy: res.data.data.user_id,
            jobName: "cataloguing",
            toolType: `CATALOGUING${
              config === "slipstream" ? "_SLIPSTREAM" : ""
            }`,
            toolName: "CataloguingTool",
            jobId: config === "slipstream" ? 42 : 41,
            pipelineJobId: null,
            toolId: toolID,
            action: bin ? "BIN" : "ATTACH",
            confidence: 0.4,
            score: res.data.data.garment_similarity_score,
            index: seedGarment.index,
            vector: seedGarment.vector,
            uuidPublicId: seedGarment.uuid_public_id,
            garmentsSeen: updatedGarmentsSeen,
            totalGarmentsSeen: updatedTotalGarmentsSeen,
            associatedGarmentId: selectedCatalogueItem.garment_id,
            associatedProposalGroupUuid:
              res.data.data.associated_group_id,
            originalProposalGroupUuid:
              res.data.data.original_group_id,
            usedVectorNamespaceId: indexSummary.namespaceStats.vectorNamespaceId ?? 0,
            skipped: bin,
            qa: false,
            slipstream: config === "slipstream",
            updateGroupRepresentative: update_representative,
          });
          
          setSeedGarmentGroupID(res.data.data.associated_group_id);
  
          if (update_representative) {
            handleUpdateGroupRepresentative(res.data.data.associated_group_id, updatedGarmentsSeen, updatedTotalGarmentsSeen);
          } else {
            resetState();
            fetchNamespaceData();
            setGarmentsSeen(0);
            setButtonDisabled(false);
          }
  
          const t2 = logPerformancePoint(2, t1);
          setButtonDisabled(false);
          setShowLoader(false);
        })
        .catch((err) => {
          console.log(err);
          showAlert(err);
          setButtonDisabled(false);
          setShowLoader(false);
        });
    }
  };

  const handleCancel = () => {
    setSelectedCatalogueGarment({});
    setAssociatedGarmentModalOpen(false);
  };

  const handleBin = async () => {
    if (!buttonDisabled)
    {
      await asssociateToCatalogItem(false,true);
    }
  };

  const resetState = () => {
    setSeedGarment({});
    setSeedGarmentVector(null);
    setSeedGarmentGroupID(null);
    setButtonDisabled(false);
    setSeedGarmentImages([]);
    setMetaData({});
    setGarments([]);
    setGarmentsSeen(0);
    setPage(1);
    setSelectedCatalogueGarment({});
    setCatalogueExhausted(false);
  };

  return (
    <Box
      sx={{
        height: `calc(100vh - ${APP_BAR_HEIGHT}px)`,
        display: "flex",
        flexDirection: "column",
        p: 1,
      }}
    >
      {/* Top Box with Fixed Height */}
      <Box
        sx={{
          height: "120px",
          flexShrink: 0,
          p: 1,
        }}
      >
        <Box
          sx={{
            justifyContent: "flex-end",
            flexDirection: "row",
            display: "flex",
            flex: 1,
          }}
        >
            <Typography variant="h2" sx={{ flex: 1 }}>
              {title}
            </Typography>
            <StyledButton
              variant="outlined"
              sx={{ mr: 2 }}
              color="primary"
              onClick={createNewCatalogItem}
              disabled={buttonDisabled || pagesVisited.length < maxPage || time < timerLengthSeconds}
            >
              Create New
            </StyledButton>
            <StyledButton
              variant="outlined"
              color="error"
              sx={{ mr: 2 }}
              onClick={handleBin}
              disabled={buttonDisabled || pagesVisited.length < maxPage || time < timerLengthSeconds}
            >
              Bin
            </StyledButton>
            <PageChangeButton
              setPage={setPage}
              page={page}
              maxPage={maxPage}
              forwardDisabled={buttonDisabled || time < timerLengthSeconds}
              backDisabled={buttonDisabled || (time < timerLengthSeconds && !pagesVisited.includes(page))}
              exhausted={catalogueExhausted}
              setPagesVisited={setPagesVisited}
              pagesVisited={pagesVisited}
            />
        </Box>

        <Box
          sx={{
            justifyContent: "flex-end",
            float: "right",
            flexDirection: "row",
            display: "flex",
            mt: 1,
            width: "19rem"
          }}
        >
          <LoadingBar time={time} maxTime={timerLengthSeconds}/>
        </Box>

        <Box
          sx={{
            flexDirection: "row",
            display: "flex",
            marginTop: 0,
          }}
        >
          <DatasetDropdown
            dataset={selectedDataset}
            setDataset={setSelectedDataset}
            sx={{ mr: 2 }}
          />
          <PineconeIndexDropdown
            index={openSearchIndex}
            setIndex={setOpenSearchIndex}
          />
          <Select
            value={numberOfColumns}
            onChange={(e) => setNumberOfColumns(e.target.value)}
            displayEmpty
            sx={{ ml: 2 }}
          >
            <MenuItem value={4}>4 Columns</MenuItem>
            <MenuItem value={5}>5 Columns</MenuItem>
            <MenuItem value={6}>6 Columns</MenuItem>
            <MenuItem value={7}>7 Columns</MenuItem>
            <MenuItem value={8}>8 Columns</MenuItem>
          </Select>

          {routePrefix === "groups" && 
          <Button
            variant="contained-white"
            color="primary"
            sx={[{
              //overflow: "hidden",
              //whiteSpace: "nowrap"
              py: 1,
              ml: 2,
              mb: 1
              },
              summonOnlyQAGroups && {
                  backgroundColor: `${palette.primary[300]} !important`,
                  color: `${palette.primary.main} !important`
              }]}
            onClick={() => setSummonOnlyQAGroups(!summonOnlyQAGroups)}
          >
            {summonOnlyQAGroups ? `ONLY QA` : `ALL`} GROUPS
          </Button>
          }
        </Box>     
      </Box>

      <Divider
        sx={{
          m: 1,
        }}
      />

      {/* Main Content Area */}
      {((!seedGarment || Object.keys(seedGarment).length === 0) && (!summonTotal || summonTotal === 0))
        ? (
          <Box sx={{ mt: 2 }}>
            <NoDataScreenCover />
          </Box>
        )
        : (openSearchIndex ? (
          <Box
            sx={{
              flexGrow: 1, // Fills the remaining space
              display: "flex",
              overflow: "hidden", // Ensures no overflow outside this box
            }}
          >
            <Box
              sx={{
                width: "25%",
              }}
            >
              <Box sx={{ padding: 2, pt: 0, maxHeight: "100% !important", marginBottom: -2, overflowY: "scroll" }}>
                <Typography variant="h3" sx={{mb: 1}}>Seed Garment</Typography>
                <Box>
                  <StyledImageCarousel srcs={seedGarmentImages}/>
                </Box>
                <Typography variant="h3" sx={{mt: 2}}>{seedGarment.title}</Typography>
                <Typography variant="body1" sx={{mt: 0.5, userSelect: "text"}}>
                  <b>ID:</b> {seedGarment.garment_id}
                </Typography>
                <Typography variant="body1" sx={{userSelect: "text"}}>
                  <b>UUID:</b> {seedGarment.uuid_public_id}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                width: "75%",
                overflowY: "auto", // Enables scrolling,
                height: "100%",
                p: 2,
                pt: 0,
                maxHeight: "100%"
              }}
            >
              <Typography variant="h3" sx={{mb: 1, ml: 1}}>Garment Pool</Typography>
              <SingleSelectGarmentWindow
                selectedGarment={selectedCatalogueItem}
                setSelectedGarment={setSelectedCatalogueGarment}
                garments={garments}
                multiImageClickablePreview={true}
                scrollPreview={true}
                numberOfColumns={numberOfColumns}
                showNoDataScreen={!showLoader}
                maxHeight="20vh"
                groupRepresentativeBorder={true}
              />
            </Box>
          </Box>
        ) : (
            <Box sx={{ mt: 2 }}>
              <TakeActionScreenCover />
            </Box>
          ))}
      <CustomModal
        showModal={associateGarmentModalOpen}
        title="Confirm Association"
        body={<Typography sx={{ color: theme.palette.primary[800] }} component="span">
          Does the seed garment match the selected garment in the garment pool?{' '}
          <Typography
            component="span"
            sx={{ fontWeight: 'bold', color: theme.palette.primary[800] }}
          >
            [<b>REP ID:</b> {selectedCatalogueItem.garment_id}]
          </Typography>{' '}
          <Typography
            component="span"
            sx={{ fontWeight: 'bold', color: theme.palette.success[600] }}
          >
            (green border)
          </Typography>
        </Typography>}
        onDismiss={handleCancel}
        onConfirm={() => {
          setAssociatedGarmentModalOpen(false);
          if (((selectedCatalogueItem.can_change_rep === null || selectedCatalogueItem.can_change_rep === undefined) || selectedCatalogueItem.can_change_rep))
          {
            setUpdateGroupRepresentativeModalOpen(true);
          } else {
            asssociateToCatalogItem(false);
          }
        }}
        onDismissTitle="Cancel"
        onConfirmTitle="Confirm"
        timerLengthSeconds={5}
      />
      <RepresentativeGarmentModal
        showModal={updateGroupRepresentativeModalOpen}
        title="Update Representative"
        body={<Typography sx={{fontSize: "1.25rem"}}>Please choose the <b>best</b> representative image</Typography>}
        onDismiss={() => {
          asssociateToCatalogItem(true);
          setUpdateGroupRepresentativeModalOpen(false);
        }}
        onConfirm={() => {
          asssociateToCatalogItem(false);
          setUpdateGroupRepresentativeModalOpen(false);
        }}
        onDismissTitle=""
        onConfirmTitle=""
        seedGarment={seedGarment}
        selectedGarment={selectedCatalogueItem}
      />
      <LoadingOverlay open={showLoader} />
    </Box>
  );
}

export default CataloguingTool;